// @ts-nocheck
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useScreenSize } from "../../../../../hooks/useScreenSize";
import { useNavigate } from "react-router-dom";
import { getCustomerByStationId } from "../../../../../services/clearing/customers";

export type CustomerActionButtonsProps = {
  stationId: string;
};

export default function CustomerActionButtons({
  stationId,
}: CustomerActionButtonsProps) {
  const [customerId, setCustomerId] = useState<string | null>(null);
  const { isMobile } = useScreenSize();
  const navigate = useNavigate();

  useEffect(() => {
    getCustomerByStationId(stationId).then((res) => {
      setCustomerId(res);
    });
  }, [stationId]);

  return (
    <div>
      <Button
        icon="pi pi-external-link"
        label={isMobile ? "" : "Jump to customer"}
        outlined
        disabled={!customerId}
        onClick={() => navigate(`/customers/${customerId}`)}
      />
    </div>
  );
}
